// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"65a9dc58c22f670d","9651":"2e6336798a5da950"}[chunkId] + ".js";
};